<script setup lang="ts">
import { computed } from "vue";
import ProjectListContent from "./ProjectListContent.vue";
import { useProjectsList } from "@/v2Projects/composables/useProjectsList";

const {
  side,
  activeTab,
  clientGroups,
  expertProjects,
  totalCount,
  isLoading,
  error,
  refetch,
} = useProjectsList();

activeTab.value = "active";

const emptyDescription = computed(() =>
  side.value === "expert"
    ? "Projects that are quoted, in progress, or submitted will appear here."
    : "Projects that are pending, quoted, in progress, or submitted will appear here.",
);
</script>

<template>
  <ProjectListContent
    :side="side"
    :is-loading="isLoading"
    :error="(error as Error | null)"
    :client-groups="clientGroups"
    :expert-projects="expertProjects"
    :total-count="totalCount"
    empty-title="No active projects"
    :empty-description="emptyDescription"
    @retry="refetch"
  />
</template>
